import React from "react";
import { IntegrationAccount } from "@common/types/integrationAccount";
import {
    solidVariantProps,
    type SolidButtonSize,
    type SolidButtonVariant,
} from "@components/financialConnection/ConnectionActionButton";
import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import { useIntegrationAccountRemovalMutation } from "@mutations/integrationAccount";
import { useToaster } from "@design-system/ToastMessages/useToaster";

interface Props {
    account: IntegrationAccount;
    variant?: SolidButtonVariant;
    size?: SolidButtonSize;
    className?: string;
    children: React.ReactNode;
}

export const RemoveIntegrationAccount: React.FC<Props> = ({
    account,
    children,
    variant = "secondary",
    size = "md",
    className,
}) => {
    const { toast } = useToaster();
    const removal = useIntegrationAccountRemovalMutation(account, () => {
        toast("Account removed");
    });

    const sharedProps = {
        onClick: () => {
            removal.mutate();
        },
        loading: removal.isPending,
        className,
        children,
    };

    return (
        <ButtonWithLoader
            {...sharedProps}
            {...solidVariantProps(variant, size)}
            iconOnly
            aria-label="Remove account"
        />
    );
};
